/**
 * `?next=` is only ever followed when it is a **same-origin path**: an absolute URL or a
 * protocol-relative one would turn the login page into an open redirect (M0-F3 §8.2).
 */
export function safeNextPath(raw: string | null): string {
  if (!raw) return '/';
  if (!raw.startsWith('/') || raw.startsWith('//')) return '/';
  return raw;
}
